/**
 * Extracts suggestion content from DOM elements (used by SuggestedChangeView)
 */
export function extractSuggestionFromDOM(changesBlobEl: Element): string[] {
  const additionChangesEl = [...changesBlobEl.querySelectorAll('.js-blob-code-addition')]
  return additionChangesEl.map(x => x.textContent).filter((text): text is string => text !== null)
}

// Maximum comment body length to prevent ReDoS attacks (100KB)
const MAX_COMMENT_BODY_LENGTH = 100000

/**
 * Extracts suggestion content from markdown body text
 * This mirrors the server-side extraction logic
 *
 * Security: Input length is limited to prevent ReDoS attacks
 */
export function extractSuggestionFromMarkdown(body: string): string[] | null {
  // Prevent ReDoS by limiting input length
  if (!body || body.length > MAX_COMMENT_BODY_LENGTH) {
    return null
  }

  const lines = body.split(/\r?\n/)
  let inSuggestionBlock = false
  let indent = ''
  const suggestionLines: string[] = []

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i]

    // Skip undefined lines
    if (line === undefined) {
      continue
    }

    if (!inSuggestionBlock) {
      // Check for opening fence: optional indent + fence + "suggestion"
      const openMatch = line.match(/^( {0,3})(`{3,}|~{3,})suggestion[ \t]*$/)
      if (openMatch) {
        inSuggestionBlock = true
        indent = openMatch[1] || ''
        continue
      }
    } else {
      // Check for closing fence
      const closeMatch = line.match(/^ {0,3}(`{3,}|~{3,})[ \t]*$/)
      if (closeMatch) {
        // Found closing fence - return the collected lines
        return suggestionLines
      }

      // Strip leading indentation from the suggestion line
      let processedLine = line
      if (indent.length > 0) {
        const indentRegex = new RegExp(`^ {0,${indent.length}}`)
        processedLine = line.replace(indentRegex, '')
      }

      suggestionLines.push(processedLine)
    }
  }

  // If we finished the loop without finding a closing fence, no valid suggestion
  return null
}
